import * as React from 'react'

import { SVGResponsive } from '../common'

interface IProps {
  width?: number
  height?: number
}

interface IProps {
  size: 'big' | 'small'
}

function AcceptingEnrollments(props: IProps) {
  const { size } = props

  switch (size) {
    case 'big':
      return renderBig()
    case 'small':
      return renderSmall()
  }
}

function renderBig() {
  return (
    <SVGResponsive height={88} width={94}>
      <g clip-path="url(#a)">
        <rect
          y="36.895"
          width="85.911"
          height="51.547"
          rx="8"
          transform="rotate(-7.51 0 36.895)"
          fill="#CBCBCB"
        />
        <path
          d="M20.353 38.662 47.622 4.607 69.134 31.85l-48.781 6.81Z"
          stroke="#9A9A9A"
          stroke-width="2"
        />
        <rect
          x="1.322"
          y="35.573"
          width="85.911"
          height="51.547"
          rx="8"
          transform="rotate(-7.51 1.322 35.573)"
          fill="#fff"
        />
        <rect
          x="4.288"
          y="37.849"
          width="80.624"
          height="46.26"
          rx="8"
          transform="rotate(-7.51 4.288 37.849)"
          stroke="#F1F1F1"
          stroke-width="2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.291 45.066a3.26 3.26 0 0 1 .535 4.606l-11.8 14.783a3.323 3.323 0 0 1-4.56.601l-6.922-5.1a3.26 3.26 0 0 1-.677-4.587 3.323 3.323 0 0 1 4.623-.681l4.352 3.206 9.808-12.288a3.323 3.323 0 0 1 4.641-.54Z"
          fill="#6FCF97"
        />
        <circle cx="47.277" cy="3.965" r="3.965" fill="#FFC6BE" />
        <path
          d="M23.513 25.414a2.33 2.33 0 0 0-.927-.927l-.44-.24a.282.282 0 0 1 0-.494l.44-.24c.392-.215.713-.535.927-.927l.24-.44a.28.28 0 0 1 .493 0l.24.44c.215.392.535.713.927.927l.44.24a.282.282 0 0 1 0 .494l-.44.24a2.325 2.325 0 0 0-.926.927l-.24.44a.28.28 0 0 1-.493 0l-.241-.44ZM16.27 30.12a3.495 3.495 0 0 0-1.391-1.39l-.66-.36a.423.423 0 0 1 0-.74l.66-.36a3.493 3.493 0 0 0 1.39-1.39l.361-.66a.42.42 0 0 1 .74 0l.36.66a3.496 3.496 0 0 0 1.39 1.39l.66.36a.422.422 0 0 1 0 .74l-.66.36a3.489 3.489 0 0 0-1.39 1.39l-.36.66a.42.42 0 0 1-.74 0l-.36-.66ZM73.513 85.414a2.33 2.33 0 0 0-.927-.927l-.44-.24a.282.282 0 0 1 0-.494l.44-.24c.392-.215.713-.535.927-.927l.24-.44a.28.28 0 0 1 .493 0l.24.44c.215.392.535.713.927.927l.44.24a.282.282 0 0 1 0 .494l-.44.24a2.325 2.325 0 0 0-.926.927l-.24.44a.28.28 0 0 1-.493 0l-.241-.44ZM81.27 87.12a3.495 3.495 0 0 0-1.391-1.39l-.66-.36a.423.423 0 0 1 0-.74l.66-.36a3.493 3.493 0 0 0 1.39-1.39l.361-.66a.42.42 0 0 1 .74 0l.36.66a3.496 3.496 0 0 0 1.39 1.39l.66.36a.422.422 0 0 1 0 .74l-.66.36a3.489 3.489 0 0 0-1.39 1.39l-.36.66a.42.42 0 0 1-.74 0l-.36-.66Z"
          fill="#DBF3E5"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h94v88H0z" />
        </clipPath>
      </defs>
    </SVGResponsive>
  )
}

function renderSmall() {
  return (
    <SVGResponsive width={50} height={48}>
      <path
        d="M.572 24.451a4.366 4.366 0 0 1 3.767-4.896l37.922-4.984a4.375 4.375 0 0 1 4.91 3.756l2.543 19.223a4.366 4.366 0 0 1-3.768 4.896L8.026 47.43a4.374 4.374 0 0 1-4.912-3.756L.572 24.451Z"
        fill="#CBCBCB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.058 1.637 9.848 21.818l28.997-4.036L26.058 1.637Zm-.006 1.752-13.63 16.97 24.382-3.394L26.052 3.39Z"
        fill="#9A9A9A"
      />
      <path
        d="M1.295 23.73a4.366 4.366 0 0 1 3.768-4.896l37.92-4.984a4.374 4.374 0 0 1 4.912 3.756l2.542 19.223a4.366 4.366 0 0 1-3.768 4.896L8.75 46.71a4.374 4.374 0 0 1-4.912-3.756L1.295 23.73Z"
        fill="#fff"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.375 25.043a4.912 4.912 0 0 1 4.239-5.509l35.053-4.607c2.696-.354 5.17 1.538 5.526 4.226l2.163 16.364a4.912 4.912 0 0 1-4.238 5.508l-35.054 4.607c-2.696.354-5.17-1.538-5.525-4.225L2.375 25.043Zm4.382-4.427A3.82 3.82 0 0 0 3.46 24.9l2.164 16.364a3.828 3.828 0 0 0 4.297 3.286l35.054-4.606a3.82 3.82 0 0 0 3.296-4.285l-2.163-16.364a3.828 3.828 0 0 0-4.298-3.286L6.757 20.616Z"
        fill="#F1F1F1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.892 24.582c.782.613.913 1.737.293 2.512l-6.456 8.064a1.822 1.822 0 0 1-2.495.328l-3.787-2.782a1.775 1.775 0 0 1-.37-2.502 1.821 1.821 0 0 1 2.529-.372l2.38 1.75 5.367-6.703a1.822 1.822 0 0 1 2.54-.295Z"
        fill="#6FCF97"
      />
      <path
        d="M28.035 2.163a2.166 2.166 0 0 1-2.17 2.163 2.166 2.166 0 0 1-2.168-2.163c0-1.195.97-2.163 2.169-2.163 1.198 0 2.17.968 2.17 2.163Z"
        fill="#FFC6BE"
      />
      <path
        d="M12.864 13.862a1.272 1.272 0 0 0-.507-.505l-.24-.131a.154.154 0 0 1 0-.27l.24-.13c.215-.118.39-.292.507-.506l.132-.24a.153.153 0 0 1 .27 0l.131.24c.117.214.293.388.507.505l.241.131a.153.153 0 0 1 0 .27l-.24.13a1.27 1.27 0 0 0-.508.506l-.132.24a.153.153 0 0 1-.269 0l-.132-.24ZM8.901 16.43a1.91 1.91 0 0 0-.76-.759l-.361-.196a.23.23 0 0 1 0-.404l.36-.197c.322-.175.585-.437.761-.758l.198-.36a.23.23 0 0 1 .404 0l.197.36c.176.321.44.583.761.759l.361.196a.23.23 0 0 1 0 .404l-.361.197a1.905 1.905 0 0 0-.76.758l-.198.36a.23.23 0 0 1-.404 0l-.198-.36ZM40.22 46.589a1.273 1.273 0 0 0-.507-.506l-.24-.131a.154.154 0 0 1 0-.27l.24-.13c.214-.117.39-.292.507-.506l.132-.24a.154.154 0 0 1 .269 0l.132.24c.117.214.292.389.507.506l.24.13a.153.153 0 0 1 0 .27l-.24.131a1.27 1.27 0 0 0-.507.506l-.132.24a.153.153 0 0 1-.27 0l-.131-.24ZM44.464 47.52a1.909 1.909 0 0 0-.761-.759l-.361-.196a.23.23 0 0 1 0-.404l.361-.197c.321-.175.585-.437.76-.758l.198-.36a.23.23 0 0 1 .404 0l.198.36c.176.32.439.583.76.759l.362.196a.23.23 0 0 1 0 .404l-.362.197a1.905 1.905 0 0 0-.76.758l-.198.36a.23.23 0 0 1-.404 0l-.197-.36Z"
        fill="#DBF3E5"
      />
    </SVGResponsive>
  )
}

export default React.memo(AcceptingEnrollments)
